<template>
  <div>
    <v-row>
      <v-col md="12" align="center">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr v-if="factoren && factoren.length>0">
                <th class="text-left"></th>
                <th class="text-center" colspan="7">{{factoren[0].vPeriodeNaam}}</th>
                <th class="text-center" colspan="7">{{factoren[0].PeriodeNaam}}</th>
              </tr>
              <tr>
                <th class="text-left">Risicofactoren</th>
                <th class="text-center">Ma</th>
                <th class="text-center">Di</th>
                <th class="text-center">Wo</th>
                <th class="text-center">Do</th>
                <th class="text-center">Vr</th>
                <th class="text-center">Za</th>
                <th class="text-center">Zo</th>
                <th class="text-center">Ma</th>
                <th class="text-center">Di</th>
                <th class="text-center">Wo</th>
                <th class="text-center">Do</th>
                <th class="text-center">Vr</th>
                <th class="text-center">Za</th>
                <th class="text-center">Zo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(f,i) in factoren" :key="i">
                <td class="text-left">
                  <span :title="f.FactorToelichting">{{f.FactorNaam}}</span>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vMa_Waarde)"
                    :size="getSize(f.vMa_Waarde)"
                    :title="f.vMa_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vDi_Waarde)"
                    :size="getSize(f.vDi_Waarde)"
                    :title="f.vDi_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vWo_Waarde)"
                    :size="getSize(f.vWo_Waarde)"
                    :title="f.vWo_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vDo_Waarde)"
                    :size="getSize(f.vDo_Waarde)"
                    :title="f.vDo_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vVr_Waarde)"
                    :size="getSize(f.vVr_Waarde)"
                    :title="f.vVr_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vZa_Waarde)"
                    :size="getSize(f.vZa_Waarde)"
                    :title="f.vZa_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.vZo_Waarde)"
                    :size="getSize(f.vZo_Waarde)"
                    :title="f.vZo_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Ma_Waarde)"
                    :size="getSize(f.Ma_Waarde)"
                    :title="f.Ma_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Di_Waarde)"
                    :size="getSize(f.Di_Waarde)"
                    :title="f.Di_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Wo_Waarde)"
                    :size="getSize(f.Wo_Waarde)"
                    :title="f.Wo_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Do_Waarde)"
                    :size="getSize(f.Do_Waarde)"
                    :title="f.Do_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Vr_Waarde)"
                    :size="getSize(f.Vr_Waarde)"
                    :title="f.Vr_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Za_Waarde)"
                    :size="getSize(f.Za_Waarde)"
                    :title="f.Za_Tip"
                  >mdi-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon
                    :color="getColor(f.Zo_Waarde)"
                    :size="getSize(f.Zo_Waarde)"
                    :title="f.Zo_Tip"
                  >mdi-circle</v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-col>
      <LijnGrafiek
        :chartdata="chartdata"
        :options="options"
        class="Grafiek"
        ref="IndicatieTotaalRisico"
        :height="100"
      ></LijnGrafiek>
    </v-col>
    <v-row></v-row>
  </div>
</template>
             
<script>
import LijnGrafiek from "@/charts/lijngrafiek.vue";
export default {
  name: "ProjectFactorenEenvoudig",
  components: { LijnGrafiek },
  props: {
    periode: {
      type: Number,
      default: null
    },
    project: {
      type: Object,
      default: null
    },
    periodeeenheid: {
      type: String,
      default: null
    }
  },
  data: () => ({
    factoren: [],
    chartdata: {
      datasets: [
        {
          label: "Indicatief totaal risico",
          data: [],
          fill: false,
          lineTension: 0,
        }
      ]
    },
    options: {
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            },
            ticks: {
              min: 0,
              max: 14,
              display: false,
            }
          }
        ],
        yAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Indicatief totaal risico"
            },
            ticks: {
              display: false,
              beginAtZero: true,
              min: 0,
              max: 5
            },
            gridLines: {
              drawBorder: true,
              display: true,
              lineWidth: 0
            }
          }
        ]
      }
    }
  }),
  methods: {
    loadData: function() {
      if (this.periode && this.project) {
        let data = {
          ProjectId: this.project.Id,
          PeriodeId: this.periode
        };

        this.$api.pProjectDashboardFactorenEenvoudig(data).then(response => {
          this.factoren = response.data;
        });

        this.$api
          .pProjectDashboardIndicatiefRisicoEenvoudig(data)
          .then(response => {
            let array = [];
            let labels = [];
            for (var i = 0; i < response.data.length; i++) {
              array.push(response.data[i].Waarde);
              labels.push(response.data[i].Datum);
            }
            this.chartdata.labels = labels;
            this.chartdata.datasets[0].data = array;
            this.$refs.IndicatieTotaalRisico.update();
          });
      }
    },
    getSize: function(waarde) {
      if (waarde == null || waarde == undefined) return 0;
      return Math.abs(waarde) * 10;
    },
    getColor: function(waarde) {
      if (waarde < 0) return "red";
      else return "green";
    }
  },
  watch: {
    periode() {
      this.loadData();
    },
    project() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style scoped>

.Grafiek {
  height: 100px;
}

</style>